import React, { useState, useEffect, useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { ButtonBasic, usePagination, TableBox } from "@lk-gtcom/ecomlab-components";
import { ModalAddFields } from '../Modal/ModalAddFields/ModalAddFields';
import { useShallow } from 'zustand/react/shallow';
import { useDataTable } from '../../../../common/hooks';
import { useResponseHandler } from '../../../../common/auth';
import './CompanyCRM.scss';

interface CompanyCRMProps { }

type PaginatorParams = {
    page?: number;
    limit?: number;
    // Добавьте нужные поля
};

type PaginatorRefType = {
    page?: number;
    limit?: number;
    params: PaginatorParams;
    setTotal?: (total: number) => void;
};

interface TableProps {
    filters: any;
    sort: any;
    total: number;
    loading: boolean;
}

interface SetTableFuncs {
    setLoading: (loading: boolean) => void;
}

const CompanyCRM = ({ }: CompanyCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const {
        isModalCompany,
        setIsModalCompany,
        currentCompany,
        setCurrentCompany
    } = useGeneralStore(
        useShallow((state) => ({
            currentCompany: state.currentCompany,
            isModalCompany: state.isModalCompany,
            setCurrentCompany: state.setCurrentCompany,
            setIsModalCompany: state.setIsModalCompany,
        }))
    );
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [companyList, setCompanyList] = useState([])
    const [isModalFields, setIsModalFields] = useState(false)
    const [load, setLoad] = useState(true)

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef<PaginatorRefType>()
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    ) as any
    const { setLoading } = setTableFuncs as SetTableFuncs;
    const { loading, sort, filters } = tableProps as TableProps;

    const btns = [
        {
            btn: 'Удалить',
            func: (e: any) => {
                fetchDeleteCompany(e)
            },
        },
    ];

    // Пагинация
    const paginatorCallback = useRef();
    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef?.current?.params
    );

    // Получение списка компаний
    const fetchTableData = (params : any[], abortController = new AbortController()) => {
        let _sort;
        let filtersParam = [];

        if (params) {
            [_sort, filtersParam] = params;
        }

        // Устанавливаем loading в true только если запрос не прерван
        if (!abortController.signal.aborted) {
            setLoading(true);
        }

        let url = `https://portals.ecomru.ru/api/crm/companies/table_view`;

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: Array.isArray(filtersParam) ? filtersParam : filters,
            search: '',
            order_field: _sort?.[0] || sort?.[0],
            order_direction: _sort?.[1] || sort?.[1]
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            });
    };

    // Удаление компании
    const fetchDeleteCompany = (id : string) => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('deleted company')
                setIsTableRequest(!isTableRequest)
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (!isModalCompany) {
            const abortController = new AbortController();
            fetchTableData([], abortController)
            return () => abortController.abort();
        }
    }, [isTableRequest, isModalCompany]);

    const contextMenuArr = [
        {
            label: 'Удалить',
            onClick: (e: any) => {
                fetchDeleteCompany(e?.["id компании"]);
            },
        },
    ];

    const onAction = (e: any) => {
        setCurrentCompany(e?.["id компании"])
        setIsModalCompany(true)
    }

    return (
        <>

            {isModalFields && <ModalAddFields
                setIsModal={setIsModalFields}
                stringUrl='companies'
            />}

            <div className={`company-CRM`}>
                <div className={`company-CRM__content`}>
                    <div className={`company-CRM__btn-group`}>
                        <ButtonBasic
                            blue
                            text='+ Добавить компанию'
                            onClick={(e: MouseEvent) => setIsModalCompany(true)}
                        />

                        <ButtonBasic
                            whiteBlue
                            text='+ Создать поля'
                            onClick={(ee: MouseEvent) => setIsModalFields(true)}
                        />
                    </div>

                    <TableBox
                        {...tableProps}
                        paginator={true}
                        ref={paginatorRef}
                        fetchCallback={fetchTableData}
                        contextMenuArr={contextMenuArr}
                        onAction={onAction}
                    />
                </div>
            </div >
        </>
    );
};

export { CompanyCRM };